import { Component } from "react"

/* Constants */
import { utils, sound, env } from "../constants"

/* UUID */
import { v4 as uuidv4 } from "uuid"

/* Components */
import { Picture, Chip } from "@cuba-go/poker-ui"
import { BOXES, BET_TYPES, MAX_LOSS, createEmptyBoxes, boxStaked, boxCost } from "../constants/values"

/* Components */
// import Chip from "../components/Chip"

/* Widget Bet */
class Bet extends Component {


    constructor() {
        super()

        this.state = {
            history: [],
        }
    }

    soundBlock = () => {
        sound.play("blocked")
    }

    /* IS IT STILL WORTH TAKING A STAKE BACK?

       Only in the last two seconds of the window is it not: the deal is about to start and
       a change that late would be racing the server for it.

       The catch is that a countdown at zero does not mean "no time left" — it also means
       "no countdown yet". The clock only starts on the first stake of the round, and the
       server does not send the player a timer until a couple of seconds after that, so
       for the first few seconds of every round `currentTime` is zero with the whole window
       still to come. Reading that as "too late" is what left the buttons dead exactly when
       a player who had just put a chip down would reach for them.

       So the window is only closing if the clock is actually running. And a click that
       slips through at the wrong moment costs nothing: setStakes on the server refuses
       anything past the window and sends the slip back as it really stands. */
    canChange = () => {

        const { currentTime, isClosed } = this.props

        if (isClosed) return true

        const left = parseInt(currentTime)

        return !(left > 0 && left <= 2)
    }

    /* Clear action */
    clear = () => {

        const { setBoxes, setList, total } = this.props

        if (total && this.canChange()) {
            setBoxes(createEmptyBoxes())
            setList([])
            sound.play()
        } else {
            this.soundBlock()
        }

    }


    cancel = () => {

        const { list, boxes, setList, setBoxes, total } = this.props

        if (!total || !this.canChange()) {
            this.soundBlock()
            return
        }

        if (!Array.isArray(list) || list.length === 0) {
            this.clear()
            return
        }

        const last = list[list.length - 1]

        if (!last.prev) {
            this.soundBlock()
            return
        }

        const restored = boxes.map((box, index) => {
            const prev = last.prev.find(item => item.box === index)
            return prev ? { ...prev.stake } : box
        })

        setBoxes(restored)
        setList(list.slice(0, -1))

    }

    /* Double action — doubles every stake on every box the player is holding */
    double = () => {

        const {
            boxes,
            setBoxes,
            total,
            balance,
            list,
            max,
            setList,
            toggleBalanceError,
            toggleMaxBetError
        } = this.props

        const safeList = Array.isArray(list) ? list : []

        const held = BOXES.filter(index => boxStaked(boxes[index]))

        if (!held.length || !total) {
            this.soundBlock()
            return
        }

        /* Doubling the stakes doubles what is held against them, and it is the hold that
           has to be on the balance — a Super Double doubled costs another fifteen times
           what was added to it, not another one */
        let required = 0

        held.forEach(index => {
            required += boxCost(boxes[index])
        })

        if (balance < required) {
            toggleBalanceError()
            return
        }

        const exceedMax = held.some(index => BET_TYPES.some(type => max && ((boxes[index][type] || 0) * 2) > parseInt(max)))

        if (exceedMax) {
            toggleMaxBetError()
            return
        }

        const prev = held.map(index => ({ box: index, stake: { ...boxes[index] } }))

        const next = boxes.map((box, index) => {

            if (!held.includes(index)) return box

            const doubled = { ...box }

            BET_TYPES.forEach(type => {
                doubled[type] = (box[type] || 0) * 2
            })

            return doubled
        })

        setBoxes(next)
        setList([...safeList, { type: "double", prev }])
    }

    /* Refresh action — puts the previous round's slip back on the same three boxes */
    refresh = () => {

        const {
            last,
            boxes,
            setBoxes,
            setList,
            list,
            total,
            balance,
            toggleBalanceError
        } = this.props

        if (!Array.isArray(last) || total) {
            this.soundBlock()
            return
        }

        let required = 0

        BOXES.forEach(index => {
            const stake = last[index]
            if (!boxStaked(stake)) return
            BET_TYPES.forEach(type => {
                required += (stake[type] || 0) * MAX_LOSS[type]
            })
        })

        if (required === 0) {
            this.soundBlock()
            return
        }

        if (balance < required) {
            toggleBalanceError()
            return
        }

        const prev = BOXES.map(index => ({ box: index, stake: { ...boxes[index] } }))

        const next = boxes.map((box, index) => {

            const stake = last[index]

            if (!boxStaked(stake)) return box

            const restored = { ...box }

            BET_TYPES.forEach(type => {
                restored[type] = stake[type] ? stake[type] : 0
            })

            return restored
        })

        setBoxes(next)
        setList([...(Array.isArray(list) ? list : []), { type: "refresh", prev }])
    }

    /* SET DEFAULT CHIP */
    setActiveChip = item => {

        const { active, setActiveChip } = this.props

        /* This was `if (...) {...} {...}` — a block, not an else, so the blocked sound
           played over the top of every successful pick as well */
        if (item.key !== active) {
            setActiveChip(item.key)
            sound.play("selectchip")
        }
        else {
            this.soundBlock()
        }

    }


    /* Draw Chips */
    _chips = () => {

        /* Fields */
        const { active } = this.props
        const { chips } = this.props

        const list = utils.getChips(chips)

        return (
            <div className="chips">
                {list.map((item, index) =>
                    <div onClick={() => this.setActiveChip(item)} key={`${index}`} className={item.key === active ? `chip active-chip` : `chip`}>
                        <Chip value={item.value} chips={chips} size={60} />
                    </div>
                )}
            </div>

        )
    }


    render = () => {

        /* Fields */
        const { last, total } = this.props

        let isLastPresent = false
        if (last && Array.isArray(last)) {
            last.forEach(item => {
                if (boxStaked(item)) {
                    isLastPresent = true
                }
            })
        }

        return (
            <div className="bet">

                <div className="bet-panel">

                    <div className="bet-buttons">

                        {/* Clear Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.clear()}>
                            <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                            <span>Очистить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.cancel()}>
                            <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                            <span>Отменить</span>
                        </div>

                    </div>

                    {/* Chips */}
                    {this._chips()}

                    <div className="bet-buttons">

                        {/* Double Up Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.double()}>
                            <div className="bet-title">2x</div>
                            <span>Удвоить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${(!isLastPresent || total) && "disabled"}`} onClick={() => this.refresh()}>
                            <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                            <span>Повторить</span>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

}

export default Bet